import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanDescField,
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	TagsSelectField,
	useSettings,
	useUserData
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function PeopleDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* NAME */}
				<SimpleTextField
					name="peop_name"
					label={t('DETAILS_PEOPLE_FIELD_NAME')}
					value={props.model.peop_name}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* SURNAME */}
				<SimpleTextField
					name="peop_surname"
					label={t('DETAILS_PEOPLE_FIELD_SURNAME')}
					value={props.model.peop_surname}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="peop_pest_id"
					label={t('DETAILS_PEOPLE_FIELD_STATUS')}
					systable="people_statuses"
					value={props.model.peop_pest_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="peop_pety_id"
					label={t('DETAILS_PEOPLE_FIELD_TYPE')}
					systable="people_types"
					value={props.model.peop_pety_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="peop_user_assigned_uid"
					label={t('DETAILS_PEOPLE_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.peop_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER 2 */}
				<ModuleSearchField
					name="peop_user_assigned_2_uid"
					label={t('DETAILS_PEOPLE_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.peop_user_assigned_2_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WARNING */}
				<BooleanDescField
					name="peop_warning_desc"
					label={t('DETAILS_PEOPLE_FIELD_WARNING')}
					value={props.model.peop_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BLOCKED */}
				<BooleanDescField
					name="peop_blocked_desc"
					label={t('DETAILS_PEOPLE_FIELD_BLOCKED')}
					value={props.model.peop_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={12}>
				{/* TAGS */}
				<TagsSelectField
					name="peop_tags"
					label={t('DETAILS_PEOPLE_FIELD_TAGS')}
					value={props.model.peop_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
